import { formatDistanceToNow, format as dfFormat } from "date-fns";
import { es } from "date-fns/locale";

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: es });
  } catch {
    return "—";
  }
}

export function absoluteDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return dfFormat(new Date(iso), "d MMM yyyy HH:mm", { locale: es });
  } catch {
    return "—";
  }
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat("es-GT").format(n);
}

export function formatPercent(n: number): string {
  return `${n.toFixed(1)}%`;
}
